import { CastOptionIsNotAllowed } from "/app/libraries/arcana/src/blocks/Popup/Templates/index.ts"

import { useUnit } from 'effector-react'
import { $playerSubscriptionLimitationsTranslations } from '../translations'
import * as model from './model'

interface CastOptionIsNotAllowedParams {
  smallPlayer?: boolean
}

export const CastOptionIsNotAllowedWidget = ({
  smallPlayer,
}: CastOptionIsNotAllowedParams) => {
  const playerSubscriptionLimitationsTranslations = useUnit(
    $playerSubscriptionLimitationsTranslations
  )

  const showWidget = useUnit(model.$showCastNotAllowedWidget)
  const hideCastNotAllowedWidget = useUnit(model.hideCastNotAllowedWidget)

  if (!showWidget) {
    return null
  }

  const onOk = () => {
    hideCastNotAllowedWidget()
  }

  return (
    <CastOptionIsNotAllowed
      title={playerSubscriptionLimitationsTranslations.casting_not_allowed}
      buttonTitle={playerSubscriptionLimitationsTranslations.ok_button}
      onOk={onOk}
      smallPlayer={smallPlayer}
    />
  )
}
